<template>
  <div>
    <Row :gutter="5" class="m-b-10">
        <i-col :xs="24" :sm="12" :md="6">
          <i-input size="small" v-model="query.keyword" clearable placeholder="关键字：编号、名称"></i-input>
        </i-col>
        <i-col  :xs="24" :sm="12" :md="18">
            <i-button size="small" type="primary" icon='ios-search'  @click="onSearchData">搜索</i-button>
            <i-button size="small"  type="success" class="m-l-5" @click="handleModifyServiceVersion()">新建版本</i-button>
        </i-col>
    </Row>

    <Table stripe size="small" :data="tableList" :columns="tableColumns"></Table>
    <div class="paging_style">
        <Page size="small" show-total show-elevator :current="query.pageNumber" :page-size="query.pageSize" :total="total" @on-change="handlePageNumberChange"></Page>
    </div>

    <!-- 启用设置 -->
    <SettingEffective ref="settingEffectiveRef" @setting-effective-success="onSearchData"/>
    <!-- 笔记 -->
    <VersionNote ref="versionNoteRef"/>
    <!-- 上传附件 -->
    <UploadAttachment ref="uploadAttachmentRef"/>
    <!-- 更新日志 -->
    <UpdateNote ref="updateNoteRef"/>

  </div>
</template>

<script>
import SettingEffective from '../components/SettingEffective.vue'
import VersionNote from '../components/VersionNote.vue'
import UploadAttachment from '../components/UploadAttachment.vue'
import UpdateNote from '../components/UpdateNote.vue'

import {
  getVersionPage, addVersion, updateVersionName, copyServiceVersion,
  deleteVersion
} from '@/api/msp/serviceversion'

export default {
  components: {
    SettingEffective, VersionNote, UploadAttachment, UpdateNote
  },
  data () {
    return {
      versionName: '',

      query: {
        pageSize: 10,
        pageNumber: 1,
        keyword: ''
      },
      total: 0,
      tableList: [],
      tableColumns: [
        { title: '版本编号', key: 'versionCode' },
        {
          title: '版本名称',
          render: (h, params) => {
            return h('div', [
              h('span', params.row.versionName),
              h('a',
                {
                  style: {
                    fontSize: '16px',
                    marginLeft: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleModifyServiceVersion(params.row)
                    }
                  }
                },
                [h('Icon', { props: { type: 'md-create' } })]
              )
            ])
          }
        },
        { title: '创建时间', key: 'createTime' },
        { title: '创建人', key: 'createUserName' },
        {
          title: '更新日志',
          render: (h, data) => {
            if (data.row.updateInfo) {
              return h('a', {
                on: {
                  click: () => {
                    this.onShowUpdateNote(data.row.serviceVersionId)
                  }
                }
              }, data.row.updateInfo)
            } else {
              return h('span', '-')
            }
          }
        },
        { title: '版本失效时间', key: 'unavailableTime' },
        {
          title: '生效时间',
          render: (h, data) => {
            if (data.row.status === 0) {
              return h('a', {
                on: {
                  click: () => {
                    this.onShowSettingEffective(data.row.serviceVersionId)
                  }
                }
              }, data.row.effectiveTime)
            } else {
              return h('span', data.row.effectiveTime)
            }
          }
        },
        {
          title: '是否生效',
          align: 'center',
          width: 100,
          render: (h, data) => {
            let colorClass = 'text-white'
            if (data.row.status === -1) {
              colorClass = 'text-darkgray '
            } else if (data.row.status === 1) {
              colorClass = 'money'
            }

            return h('span', {
              attrs: {
                class: colorClass
              }
            },
            data.row.statusName)
          }
        },
        {
          title: '操作',
          width: 300,
          align: 'left',
          render: (h, data) => {
            const buttons = [
              h('a', {
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.onShowVersionNote(data.row.serviceVersionId)
                  }
                }
              }, '笔记'),
              h('a', {
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.onShowUploadAttachment(data.row.serviceVersionId)
                  }
                }
              }, '上传附件'),
              h('a', {
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.onShowCoypVersion(data.row)
                  }
                }
              }, '复制并创建新版本'),
              h('a', {
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.handleEditOrDetail(data.row)
                  }
                }
              }, data.row.status < 0 ? '查看' : '编辑')
            ]

            if (data.row.status === 0) {
              buttons.push(h('a', {
                style: {
                  color: '#ef4f4f'
                },
                on: {
                  click: () => {
                    this.handleDelete(data.row)
                  }
                }
              }, '删除'))
            }

            return h('div', buttons)
          }
        }
      ]
    }
  },
  created () {
    this.loadServiceVersionData()
  },
  methods: {
    loadServiceVersionData () {
      getVersionPage(this.query).then(res => {
        this.tableList = res.list
        this.total = res.totalRow
      })
    },
    onSearchData () {
      this.query.pageNumber = 1
      this.loadServiceVersionData()
    },
    handlePageNumberChange (page) {
      this.query.pageNumber = page
      this.loadServiceVersionData()
    },
    handleEditOrDetail (params) {
      this.$store.commit('set_service_config_detailBean', params)
      this.$store.commit('set_service_config_pageType', 'detail')
    },
    handleDelete (params) {
      this.$Modal.confirm({
        title: '操作确认？',
        content: '您确定要删除【 ' +
            params.versionName +
            '】的版本吗？删除后将不可恢复！',
        loading: true,
        onOk: () => {
          deleteVersion({ versionId: params.serviceVersionId }).then(res => {
            if (res && !res.errcode) {
              this.$Notice.success({ desc: '操作成功!' })
              this.onSearchData()
            }
          }).finally(() => {
            this.$Modal.remove()
          })
        }
      })
    },
    handleModifyServiceVersion (params) {
      const _self = this
      _self.versionName = params ? params.versionName : ''

      _self.$Modal.confirm({
        title: params ? '新建版本' : '编辑版本名称',
        render: (h) => {
          return h('Input', {
            props: {
              value: _self.versionName,
              autofocus: true,
              placeholder: '请输入版本名称'
            },
            on: {
              input: (val) => {
                _self.versionName = val
              }
            }
          })
        },
        loading: true,
        onOk: () => {
          if (params) { // 编辑
            updateVersionName({
              name: _self.versionName,
              versionId: params.serviceVersionId
            }).then(res => {
              if (res && !res.errcode) {
                _self.$Notice.success({ desc: '编辑版本名称成功！' })
                _self.loadServiceVersionData()
              }
            }).finally(() => { _self.$Modal.remove() })
          } else { // 新增
            addVersion({ name: _self.versionName }).then(res => {
              _self.$Notice.success({ desc: '新建版本成功！' })
              _self.onSearchData()
            }).finally(() => { _self.$Modal.remove() })
          }
        }
      })
    },
    onShowSettingEffective (versionId) {
      this.$refs.settingEffectiveRef.showModal(versionId)
    },
    onShowVersionNote (versionId) {
      this.$refs.versionNoteRef.showModal(versionId)
    },
    onShowUploadAttachment (versionId) {
      this.$refs.uploadAttachmentRef.showModal(versionId)
    },
    onShowUpdateNote (versionId) {
      this.$refs.updateNoteRef.showModal(versionId)
    },
    onShowCoypVersion (params) {
      this.$Modal.confirm({
        title: '操作确认？',
        content: '当前复制版本为【 ' +
            params.versionName +
            '】，是否确认复制？',
        loading: true,
        onOk: () => {
          copyServiceVersion({
            versionId: params.serviceVersionId
          }).then((res) => {
            if (res && !res.errcode) {
              this.$Notice.success({ desc: '操作成功!' })
              this.onSearchData()
            }
          }).catch((error) => {
            this.$Notice.error({
              title: '服务器请求错误',
              desc: error
            })
          }).finally(() => {
            this.$Modal.remove()
          })
        }
      })
    }
  }
}
</script>
